export const capitalize = (string) => {
  return string
    .toLowerCase()
    .split(" ")
    .map((word) => {
      return word.charAt(0).toUpperCase() + word.slice(1);
    })
    .join(" ");
};

export const truncateText = (string, length = 100) => {
  if (string?.length > length) {
    return string.slice(0, length) + "...";
  } else {
    return string;
  }
};
